import React from "react";

export default function DealExpired() {
  return ( 
    <div className="min-h-screen flex flex-col items-center px-6 py-8 sm:px-4 sm:py-6">
      <img
        src="/deal-expired.png"
        alt="Deal Expired"
        className="w-full max-w-xs mb-6"
      />
      <p className="text-gray-600 text-center mb-4 text-sm sm:text-base">
        No worries — there are many more deals waiting for you!
      </p>
      <a
        href="/"
        className="text-indigo-600 hover:underline font-semibold text-base sm:text-sm"
      >
        🔙 Go to Home Page
      </a>
    </div>
  );
}
